<div
  class="med-bubble"
  [class]="styleClass"
>
  <med-icon-sync
    *ngIf="loading; else contentTemplate"
    size="16"
    class="animate--rotate"
  ></med-icon-sync>

  <button
    *ngIf="visibleCloseBtn"
    class="med-bubble__close"
    type="button"
    [disabled]="loading"
    (click)="remove.emit()"
  >
    <med-icon-x size="16px"></med-icon-x>
  </button>
</div>

<ng-template #contentTemplate>
  <span class="med-bubble__text">
    <ng-content></ng-content>
  </span>
</ng-template>
